import { graphql } from "@/gql";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";

export type RelocationLineListItem = ResultOf<
  typeof relocationLineListQuery
>["relocationLines"]["data"][0];

export type RelocationLineListVariables = VariablesOf<
  typeof relocationLineListQuery
>;

export const relocationLineListQuery = graphql(`
  query RelocationLineList(
    $page: Int
    $first: Int!
    $orderByReference: Boolean
    $orderBy: [QueryRelocationLinesOrderByOrderByClause!]
    $where: QueryRelocationLinesWhereWhereConditions
    $whereGroup: QueryRelocationLinesWhereGroupWhereHasConditions
  ) {
    relocationLines(
      page: $page
      first: $first
      orderByReference: $orderByReference
      orderBy: $orderBy
      where: $where
      whereGroup: $whereGroup
    ) {
      data {
        ...RelocationLineFields
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

graphql(`
  fragment RelocationLineFields on RelocationLine {
    id
    reference
    created_at
    sold_at
    sold_by
    group {
      id
      expires_at
      relocations {
        id
        vehicle {
          id
          name
          code
          heroImage
        }
        currency

        inclusions {
          id
          type
          value
          description
        }

        departureOffice {
          id
          name
        }
        deliveryOffice {
          name
        }
        available_from_date
        available_to_date
      }
    }
    booking {
      id
      name
      reference
    }
  }
`);
